import { useResponsive } from '@sg/garnish';

export const useLargeDesktopBreakpoint = () => {
  const { screenDimensions, minWidth } = useResponsive();

  return screenDimensions.width >= 1200 && !minWidth.isLG;
};
